import React from "react";
import s from "./style.module.scss";
import { Status } from "shared/ui/Status";
import { Help } from "./icons/Help";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { Bar } from "./Bar";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";

export const AccountStatus: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <div className={s.status}>
      <Link className={s.link} to={ROUTES_PATH.STATUSES} />
      <div className={s.top}>
        <Status
          big
          color={user_info?.user_status.color}
          type={user_info?.user_status.title}
        />

        <div className={s.help}>
          {user_info?.user_status.status_expire && (
            <span className={s.expire}>
              {user_info?.user_status.status_expire}
            </span>
          )}

          <Help />
        </div>
      </div>

      <Bar />

      {user_info?.status_list.length && (
        <ul className={s.list}>
          {user_info?.status_list.map((item) => (
            <li key={item.id} className={s.item}>
              <div className={s.left}>
                <h6>{item.title}</h6>
                <span>10₽={item.bonus_rate} балла</span>
              </div>
              <p className={s.info}>{item.status_next}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
